import { getChapterName } from '@lingoda/learning-units';

export const getLessonSubtitle = (
    moduleName: string,
    chapter: number | string,
    lessonLabel: string,
) => {
    const chapterName = typeof chapter === 'string' ? chapter : getChapterName({ chapter });

    const subtitle = [moduleName, chapterName, lessonLabel].filter(Boolean).join(' • ');

    return subtitle;
};
